import axios from "axios";
import { RequestParamsController } from "@/common/scripts/request_params_controller";

export default class GetRegionList {
  public static async getRegions() {
    try {
      const params = RequestParamsController.create_v2("get", "getRegions", {});
      const response = await axios(params);
      return response.data.res.Regions.map(
        (regionInfo: { [key: string]: string }) => {
          return regionInfo.RegionName;
        }
      );
    } catch (err) {
      console.log(err);
    }
  }
}
